import React, { useState, useEffect } from 'react'
import { KTSVG, toAbsoluteUrl } from '../../../_metronic/helpers'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify'
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import 'react-toastify/dist/ReactToastify.css';
import parsePhoneNumber from 'libphonenumber-js';
import Superadmin from '../../../Assets/image_1.png';
import SalesUser from '../../../Assets/image_2.png';
import Director from '../../../Assets/image_3.png';
import AccountUser from '../../../Assets/image_4.png';
import Consignmentuser from '../../../Assets/image_5.png';
import Supervisor from '../../../Assets/image_6.png';
import Admin from '../../../Assets/image_7.png';



type User = {
  name: string;
  email: string;
  phone_no: string;
  alter_phone_no: string;
  role: string;
};

type ProfileModalProps = {
  isOpen: boolean;
  onClose: () => void;
}

const convertRoleForAPI = (role: string): string => {
  switch (role) {
    case 'super_admin':
      return 'Superadmin';
    case 'sales_user_table':
      return 'SalesUser';
    case 'director_table':
      return 'Director';
    case 'accountuser_table':
      return 'AccountUser';
    case 'consignment_table':
      return 'Consignment user';
    case 'supervisor_table':
      return 'Supervisor';
    case 'admin_table':
      return 'Admin';
    default:
      return role; // Return original role if no match
  }
}

const roleImages = {
  'Superadmin': Superadmin,
  'SalesUser': SalesUser,
  'Director': Director,
  'AccountUser': AccountUser,
  'Consignment user': Consignmentuser,
  'Supervisor': Supervisor,
  'Admin': Admin
};

// Function to calculate profile completion percentage
const calculateProfileCompletion = (userData: {
  name: string,
  role: string,
  phone_no: string,
  alter_phone_no: string,
  email: string
}): number => {
  const fields = [
    userData.name,
    userData.role,
    userData.phone_no,
    userData.alter_phone_no,
    userData.email
  ];

  // Count non-empty fields
  const filledFields = fields.filter(field => field.trim() !== '').length;

  // Calculate percentage (max 100%)
  const percentage = (filledFields / fields.length) * 100;

  return Math.round(percentage);
}

// Utility functions (convertRoleForAPI, calculateProfileCompletion) remain the same as in original code

const Profile: React.FC<ProfileModalProps> = ({ isOpen, onClose }) => {
  const [userData, setUserData] = useState<User>({
    name: '',
    role: '',
    phone_no: '',
    alter_phone_no: '',
    email: '',
  });

  const [loading, setLoading] = useState(true);
  const [loadings, setLoadings] = useState(false);
  const [editingUser, setEditingUser] = useState<User | null>(null);
  const [showModal, setShowModal] = useState<boolean>(false);

  const [errorss, setErrorss] = useState<{
    phone_no?: string;
    alter_phone_no?: string;
  }>({});
  const [showSuccessMessage, setShowSuccessMessage] = useState<boolean>(false);

  // Fetch user data on component mount
  useEffect(() => {
    if (isOpen) {
      // Retrieve user details from local storage
      const role = localStorage.getItem('who')
      // const email = localStorage.getItem('identifier')
      const Data = localStorage.getItem('Data');
      const parsedData = Data ? JSON.parse(Data) : null; // Parse the JSON string
      const email = parsedData?.email || ''; // Extract email safely

      // Function to handle error cases
      const handleError = (message?: string) => {
        console.error(message);
        toast.error(message || 'Unable to fetch user data');
        setUserData({
          name: '',
          role: '',
          phone_no: '',
          alter_phone_no: '',
          email: '',
        });
        setLoading(false);
      }

      // Check if both role and email exist
      if (!role || !email) {
        handleError('User details not found in local storage');
        return;
      }

      // Fetch particular user data
      const fetchUserData = async () => {
        try {
          // Convert role to API-compatible format
          const apiRole = convertRoleForAPI(role);

          const response = await fetch('https://backendcway.causewaycargo.com/superadmin/getparticularuser', {
            method: 'POST',
            headers: {
              'auth': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6Nywicm9sZSI6InN1cGVyX2FkbWluIiwiaWF0IjoxNzI2ODM0MzIwfQ.edXyvu0znbVoi5KU3iL8FPww3qe8LMU0oXOCwdZi8do',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              email: email,
              role: apiRole
            }),
          });

          // Check if the response is not OK
          if (!response.ok) {
            const errorData = await response.json();
            const firstErrorMessage = errorData.errors && errorData.errors.length > 0
              ? errorData.errors[0].msg
              : 'Failed to fetch user data';

            handleError(firstErrorMessage);
            return;
          }

          const result = await response.json();

          // Check if the response status is success
          if (result.status === 'success' && result.data) {
            const userData = result.data;
            setUserData({
              name: userData.name || '',
              role: convertRoleForAPI(userData.role || ''),
              phone_no: userData.phone_no || '',
              alter_phone_no: userData.alter_phone_no || '',
              email: userData.email || '',
            });
          } else {
            // If no success status or no data
            handleError('No user data available');
          }
        } catch (error) {
          // Catch any network or parsing errors
          handleError(error instanceof Error ? error.message : 'An unexpected error occurred');
        } finally {
          setLoading(false);
        }
      }

      // Call the async function
      fetchUserData();
    }
  }, [isOpen]);

  // Calculate profile completion percentage
  const profileCompletionPercentage = calculateProfileCompletion(userData);

  // Handler for editing user
  const handleEditCustomer = (userData: User) => {
    console.log("Editing user:", userData);
    setEditingUser({ ...userData });
    setShowModal(true);
  };


  // Phone number change handlers
  const handlePhoneChange = (value?: string) => {
    if (editingUser) {
      setEditingUser({ ...editingUser, phone_no: value || '' });
      if (value) {
        if (!isValidPhoneNumber(value)) {
          setErrorss((prevErrors) => ({
            ...prevErrors,
            phone_no: 'Invalid phone number',
          }));
        } else {
          setErrorss((prevErrors) => ({
            ...prevErrors,
            phone_no: '',
          }));
        }
      } else {
        setErrorss((prevErrors) => ({
          ...prevErrors,
          phone_no: 'Phone number required',
        }));
      }
    }
  };

  const handleAlterPhoneChange = (value?: string) => {
    if (editingUser) {
      setEditingUser({ ...editingUser, alter_phone_no: value || '' });

      if (value && !isValidPhoneNumber(value)) {
        setErrorss((prevErrors) => ({
          ...prevErrors,
          alter_phone_no: 'Invalid alternate phone number',
        }));
      } else {
        setErrorss((prevErrors) => {
          const newErrors = { ...prevErrors };
          delete newErrors.alter_phone_no;
          return newErrors;
        });
      }
    }
  };

  // Form submission handler
  const handleUserFormSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!editingUser) return;

    const nameRegex = /^[A-Za-z0-9\s]{1,50}$/;

    let validationErrors: string[] = [];

    if (!nameRegex.test(editingUser.name)) {
      validationErrors.push('Name must only contain letters and spaces, and be up to 50 characters long.');
    }
    if (!editingUser.phone_no || !isValidPhoneNumber(editingUser.phone_no)) {
      validationErrors.push('Valid phone number is required.');
    }

    if (editingUser.alter_phone_no && !isValidPhoneNumber(editingUser.alter_phone_no)) {
      validationErrors.push('Valid alternate phone number is required.');
    }

    if (editingUser.phone_no === editingUser.alter_phone_no) {
      validationErrors.push('Phone number and alternate phone number cannot be the same');
    }

    if (validationErrors.length > 0) {
      toast.error(validationErrors.join('\n'));
      return;
    }

    setLoadings(true);

    try {
      const response = await fetch('https://backendcway.causewaycargo.com/superadmin/editparticularusers', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'auth': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6OCwicm9sZSI6InN1cGVyX2FkbWluIiwiaWF0IjoxNzM5NzkxMjkyfQ.lkUh_koPdgYAZkICNJ7IDGDbyRALtVmR2AjkbMpbKf0',
        },
        body: JSON.stringify({
          name: editingUser.name,
          email: editingUser.email,
          phone_no: editingUser.phone_no,
          alter_phone_no: editingUser.alter_phone_no,
          role: editingUser.role,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        const firstErrorMessage = errorData.errors.length > 0 ? errorData.errors[0].msg : 'Unknown error';
        toast.error(firstErrorMessage);
        throw new Error(firstErrorMessage);
      }

      const result = await response.json();
      if (result.status === 'success') {
        // Update userData with edited information
        setUserData(editingUser);
        setShowSuccessMessage(true);
        setTimeout(() => setShowSuccessMessage(false), 3000);
        setShowModal(false)
      }
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'An unknown error occurred';
      console.log(errorMessage)
    } finally {
      setLoadings(false);
    }
  };

  // If the modal is not open, return null
  if (!isOpen) return null;

  // If still loading, show loading indicator
  if (loading) {
    return (
      <div className="modal-backdrop rounded-5">
        <div className="modal d-block" tabIndex={-1} role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Profile</h5>
                <button type="button" className="btn-close" onClick={onClose}></button>
              </div>
              <div className="modal-body text-center">
                Loading...
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <ToastContainer />
      <div className="modal-backdrop rounded-5">
        <div className="modal d-block" tabIndex={-1} role="dialog">
          <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div className="modal-content border-0 shadow-lg">
              <div className="modal-header border-0 pb-0">
                <h5 className="modal-title text-dark fw-bold">Profile Overview</h5>
                <button type="button" className="btn-close" onClick={onClose}></button>
              </div>
              <div className="modal-body pt-6">
                <div className="row align-items-center">
                  <div className="col-md-4 text-center">
                    <div className='symbol symbol-100px symbol-lg-160px symbol-fixed position-relative'>
                      <img
                        src={toAbsoluteUrl(roleImages[userData.role as keyof typeof roleImages])}
                        alt={`${userData.role} avatar`}
                        className='rounded-circle w-90 h-90 object-cover'
                      />
                      <div className='position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-20px w-20px'></div>
                    </div>
                    {/* <div className='mt-3'>
                      <span className='badge px-3 py-2' style={{ backgroundColor: '#C42A21' }}>
                        {userData.role || "N/A"}
                      </span>
                    </div> */}
                  </div>

                  <div className="col-md-8">
                    <div className="d-flex justify-content-between align-items-start mb-4">
                      <div>
                        <h2 className='text-dark fw-bolder mb-2'>
                          {userData.name || "N/A"}
                        </h2>
                        <div className='text-muted'>Verified Profile</div>
                      </div>

                      <button
                        className='btn btn-sm btn-light-primary'
                        onClick={() => handleEditCustomer(userData)}
                      >
                        <i className='ki-outline ki-pencil me-2'></i>
                        Edit Profile
                      </button>
                    </div>

                    <div className="row g-4 mb-4">
                      <div className="col-md-6">
                        <div className="d-flex align-items-center">
                          <div className="me-3">
                            <KTSVG
                              path='/media/icons/duotune/arrows/user.svg'
                              className='svg-icon-1 svg-icon-primary fw-bolder'
                            />
                          </div>
                          <div>
                            <div className="text-muted small">Role</div>
                            <div className="fw-bold">{userData.role || "N/A"}</div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="d-flex align-items-center">
                          <div className="me-3">
                            <KTSVG
                              path='/media/icons/duotune/arrows/phone.svg'
                              className='svg-icon-1 svg-icon-primary fw-bolder'
                            />
                          </div>
                          <div>
                            <div className="text-muted small">Primary Phone</div>
                            <div className="fw-bold">{userData.phone_no || "N/A"}</div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="d-flex align-items-center">
                          <div className="me-3">
                            <KTSVG
                              path='/media/icons/duotune/arrows/phone.svg'
                              className='svg-icon-1 svg-icon-primary fw-bolder'
                            />
                          </div>
                          <div>
                            <div className="text-muted small">Alternative Phone</div>
                            <div className="fw-bold">{userData.alter_phone_no || "N/A"}</div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="d-flex align-items-center">
                          <div className="me-3">
                            <KTSVG
                              path='/media/icons/duotune/arrows/mail.svg'
                              className='svg-icon-1 svg-icon-primary fw-bolder'
                            />
                          </div>
                          <div>
                            <div className="text-muted small">Email Address</div>
                            <div className="fw-bold">{userData.email || "N/A"}</div>
                          </div>
                        </div>
                      </div>

                    </div>

                    <div className='mb-4'>
                      <div className='d-flex justify-content-between mb-2'>
                        <span className='text-muted'>Profile Completion</span>
                        <span className='fw-bold'>{profileCompletionPercentage}%</span>
                      </div>
                      <div className='progress' style={{ height: '8px' }}>
                        <div
                          className='progress-bar bg-success'
                          role='progressbar'
                          style={{ width: `${profileCompletionPercentage}%` }}
                          aria-valuenow={profileCompletionPercentage}
                          aria-valuemin={0}
                          aria-valuemax={100}
                        ></div>
                      </div>
                    </div>

                    <div className='text-end'>
                      <button
                        className='outline-0 border-0 p-0 m-0'
                        style={{ backgroundColor: 'transparent' }}
                      >
                        <Link
                          to='/logout'
                          className='btn btn-sm fs-6 d-flex gap-3 align-items-center'
                          style={{ backgroundColor: '#D4DCE1' }}
                        >
                          Logout
                          <KTSVG
                            path='/media/icons/duotune/arrows/arr092.svg'
                            className='svg-icon-1 svg-icon-primary fw-bolder'
                          />
                        </Link>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Edit Modal */}
      {showModal && editingUser && (
        <div className="modal-backdrop rounded-5">
          <div className="modal d-block" tabIndex={-1} role="dialog">
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Edit User</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => {
                      setEditingUser(null);
                      setShowModal(false);
                    }}
                  >
                  </button>

                </div>
                <div className="modal-body">
                  <form onSubmit={handleUserFormSubmit}>
                    <div className="mb-3">
                      <label className="form-label">Name<span className="text-danger">*</span></label>
                      <input
                        type="text"
                        className="form-control"
                        value={editingUser.name}
                        onChange={(e) => {
                          const trimmedValue = e.target.value.trimStart();
                          const sanitizedValue = trimmedValue.replace(/[^A-Za-z0-9\s]/g, '');
                          setEditingUser({ ...editingUser, name: sanitizedValue });
                        }}
                        placeholder="Enter Your Name"
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Email<span className="text-danger">*</span></label>
                      <input
                        readOnly
                        type="email"
                        className="form-control"
                        value={editingUser.email}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Phone Number<span className="text-danger">*</span></label>
                      <PhoneInput
                        international
                        countryCallingCodeEditable={false}
                        defaultCountry="AE"
                        value={editingUser.phone_no || ''}
                        className="form-control"
                        onChange={handlePhoneChange}
                        placeholder="Enter phone number"
                      />
                      {errorss.phone_no && <div className="text-danger">{errorss.phone_no}</div>}
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Alternate Phone Number</label>
                      <PhoneInput
                        international
                        countryCallingCodeEditable={false}
                        defaultCountry="AE"
                        value={editingUser.alter_phone_no || ''}
                        className="form-control"
                        onChange={handleAlterPhoneChange}
                        placeholder="Enter alternate phone number"
                      />
                      {errorss.alter_phone_no && <div className="text-danger">{errorss.alter_phone_no}</div>}
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Role</label>
                      <input
                        type="text"
                        className="form-control"
                        value={editingUser.role}
                        readOnly
                      />
                    </div>

                    <div className="text-end">
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={loadings || !!errorss?.phone_no || !!errorss?.alter_phone_no}
                      >
                        {loadings ? 'Saving...' : 'Save changes'}
                      </button>

                      <span
                        className="btn btn-secondary ms-2"
                        onClick={() => setEditingUser(null)}
                      >
                        Close
                      </span>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Success Message Modal */}
      {showSuccessMessage && (
        <div className='modal-backdrop shadow-lg rounded-5'>
          <div className='modal d-block' tabIndex={-1} role='dialog'>
            <div className='modal-dialog modal-dialog-centered' role='document'>
              <div className='modal-content pb-10 pt-4'>
                <div className='modal-header py-2 d-flex justify-content-end'>
                  <span className='close-btn' onClick={() => setShowSuccessMessage(false)}>🗙</span>
                </div>
                <div className='text-center'>
                  <img alt='Logo' src={toAbsoluteUrl('/media/illustrations/sigma-1/12-dark.png')} className='w-250px mb-6 runningImage' />
                  <h2>Edited successfully!</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export { Profile };